import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DateProvider } from '../../../providers';
import FontFamilyHeader from '../../FontFamilyHeader';
import LogoImg from './laliga-logo.svg';
import LaLigaFont from './LALIGAPlayers-Regular.woff2';
import {
  Container,
  ColorsContainer,
  ColorsItem,
  Logo,
  LogoContainer,
  Points,
  PointsContainer,
  Row,
  Space,
  TeamName,
  TeamLogo,
  Timer,
  TimerContainer,
} from './styles';

function SoccerLaLigaHypermotion({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return ['00', '00'];
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return [minutes, seconds];
  };

  const [minutes, seconds] = getTime();

  return (
    <>
      <FontFamilyHeader
        family={{
          isGoogleFont: false,
          name: 'LaLigaESSports',
          url: LaLigaFont,
        }}
      />
      <Container>
        <Row>
          <LogoContainer>
            <Logo src={LogoImg} />
          </LogoContainer>
          <TeamName $hasTeamImage={!!homeTeam.image}>
            <span>{homeTeam.name}</span>
            {!!homeTeam.image && <TeamLogo src={homeTeam.image} />}
          </TeamName>
          {homeTeam?.colors && (
            <ColorsContainer>
              {homeTeam?.colors.map((color) => (
                <ColorsItem
                  style={{ background: color.value }}
                  key={color.id}
                />
              ))}
            </ColorsContainer>
          )}
          <PointsContainer>
            <Points>{homeTeam.points}</Points>
          </PointsContainer>
        </Row>
        <Space />
        <Row>
          <TimerContainer>
            <Timer>
              {minutes}
              <span>:</span>
              {seconds}
            </Timer>
          </TimerContainer>
          <TeamName $hasTeamImage={!!awayTeam.image}>
            <span>{awayTeam.name}</span>
            {!!awayTeam.image && <TeamLogo src={awayTeam.image} />}
          </TeamName>
          {awayTeam?.colors && (
            <ColorsContainer>
              {awayTeam?.colors.map((color) => (
                <ColorsItem
                  style={{ background: color.value }}
                  key={color.id}
                />
              ))}
            </ColorsContainer>
          )}
          <PointsContainer>
            <Points>{awayTeam.points}</Points>
          </PointsContainer>
        </Row>
      </Container>
    </>
  );
}

SoccerLaLigaHypermotion.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

SoccerLaLigaHypermotion.defaultProps = {
  data: {
    awayTeam: {
      colors: [{ id: 1, value: '#fff' }],
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/RealMadridLogoWhite.svg',
      name: 'RMD',
      points: 0,
    },
    homeTeam: {
      colors: [
        { id: 1, value: '#fff' },
        { id: 2, value: '#E2231A' },
      ],
      image:
        'https://overlayon.s3.eu-west-3.amazonaws.com/AthleticClubLogoWhite.svg',
      name: 'ATH',
      points: 0,
    },
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default SoccerLaLigaHypermotion;
